import {ComponentProps} from 'react';

import {Colors, Text} from '@optimaxdev/design-system';

/**
 * Returns common text props for GlassesItemDetails
 */
export const getCommonTextProps = (): ComponentProps<typeof Text> => ({
    as: 'p',
    color: Colors.limedSpruce,
    lineHeight: '24px',
    margin: '0 0 4px',
    size: '16px',
});
